import { PageInfo } from '../../../core/model/pagination/page-info';
import { Globals } from '../../../app.globals';
import { Params } from '@angular/router/src/shared';

export const PAGE = 'page';
export const SIZE = 'size';

/**
 * Function returns hash object to be used in router navigation containing paging info for tpp/cards.
 * @param {PageInfo} pageInfo
 * @return {{}} object with PAGE and SIZE keys
 */
export const asRouterParams = (pageInfo: PageInfo) => ({
        [PAGE]: pageInfo.page,
        [SIZE]: pageInfo.itemsPerPage }
);

/**
 * SSF-253 / ALM 49302: Stránkování při smazání aplikace
 *
 * If deleted application is the only item on a page then it is required to load previous page instead of refresh of
 * current page.
 *
 * It´s permissible to ask BE for the 0. page even if there are no applications at all. BE will respond correctly.
 * However, it´s not possible to ask for any other page in the same case.
 *
 * @param {PageInfo} pageInfo
 * @return {{}}
 */
export const asRouterParamsCheckLastItem = (pageInfo: PageInfo) => ({
        [PAGE]: pageInfo.page === 0 ? 0 : pageInfo.page - 1,
        [SIZE]: pageInfo.itemsPerPage }
);

/**
 * Method creates page PageInfo query params. If params are not available then it uses default values.
 * @param {Params} queryParams
 * @param {number} defaultSize if not present in query params
 * @return {PageInfo}
 */
export const pageInfoFromQueryParams = (queryParams: Params, defaultSize: number): PageInfo => {
    return new PageInfo(
        queryParams[PAGE] ? queryParams[PAGE] : Globals.firstPage,
        queryParams[SIZE] ? queryParams[SIZE] : defaultSize);
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/helper/router-params.ts